import { Backdrop, Box, Button, Checkbox, CircularProgress, FormControl, FormControlLabel, Grid, ListItem, ListItemIcon, Radio, RadioGroup, Typography, } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import DialogComponent from '../../component/dialog/dialog.component';
import MenuListComponent, { MenuListItem } from './menu-list/menu-list-component';

import { Condiments, FirstMenu, ItemUnit, ITEM_TYPE, MenuDish, SecondMenu, TaxGroup } from '../../models';
import { apiManage_rbp } from '../../request';
// css
import './scss/classify-menu-library.scss'
import i18n from '../../i18n';
import MenuDishComponent from './menu-dish.component';
import CommonInput from '../../component/form/common-input.component';
import MuliSettingDishDialog from './multi-setting-dialog.component';
import { Delete, FileCopyOutlined, SyncAlt, Visibility } from '@mui/icons-material';
import GlobalNotification from '../../component/common/snackbar';
import setLoading from '../../component/linear-determinate';
import ButtonComponent from '../../component/button/button.component';
import ReactVirtualizedTable from '../../component/table/react-virtualized-table';
import { HeadCell } from '../../component/table/table.component';
import axios, { Canceler } from 'axios';

enum DISH_ACTION_TITLE {
    'COPY_DISH' = 'menu_and_dishes_page_copy_dishes',

    'TRANSFER_DISH' = 'menu_and_dishes_page_transfer_dishes',
}

export default class AllDishList extends React.PureComponent<Props, State> {

    public tableRef: React.RefObject<any> = React.createRef();
    public dialogRef: React.RefObject<any> = React.createRef();
    public ReactVirtualizedTableRef: React.RefObject<any> = React.createRef();
    // 取消请求
    public canceler: Canceler | null = null;

    public state: State = {
        // 全部菜品
        allDishesList: [],
        // 是否加载中
        isLoading: false,
        // 是否显示菜单列表对话框
        isShowMenuListDialog: false,
        // 当前选中的菜品
        dishSelected: [],
        // 是否显示确认对话框
        isShowConfirmDialog: false,
        // 选中的二级菜单id
        checkedSecondMenuIds: [],
        // 当前选中的二级菜单
        checkedSecondMenus: [],
        // 当前菜品详情
        menuDishData: undefined,
        // 是否显示菜品详情
        isShowMenuDishData: false,
        // 菜品操作标题
        actionTitle: 'menu_and_dishes_page_copy_dishes' as DISH_ACTION_TITLE.COPY_DISH,
        // 批量设置数组
        multiSettingArr: [
            {
                label: i18n.t('menu_and_dishes_page_dish_type'),
                key: 'item_type',
                value: 0,
                type: 'radio',
                items: [
                    { label: i18n.t('menu_and_dishes_page_normal_dishes'), value: 0 },
                    { label: i18n.t('menu_and_dishes_page_dish_with_current_price'), value: 2 },
                    { label: i18n.t('menu_and_dishes_page_set_meal'), value: 3 },
                    { label: i18n.t('menu_and_dishes_page_custom_dish'), value: 4 },
                    { label: i18n.t('menu_and_dishes_page_text'), value: 5 },
                ],
                checked: false,
            },
            {
                label: i18n.t('menu_and_dishes_page_print_class'),
                key: 'print_class',
                value: -1,
                type: 'select',
                items: this.props.printGroup?.map((item) => ({
                    label: item.print_class_name || '',
                    value: item.print_class_id || 0,
                })),
                checked: false,
            },
            {
                label: i18n.t('tax_group_page_label'),
                key: 'tax_group',
                value: -1,
                type: 'select',
                items: this.props.taxGroup.map((item) => ({
                    label: item.tax_group_name || '',
                    value: item.tax_group_id || 0,
                })),
                checked: false,
            },
            {
                label: i18n.t('menu_and_dishes_page_form_main_type'),
                key: 'major_group',
                value: -1,
                type: 'select',
                items: this.props.majorGroup.map(item => ({
                    label: item.major_group_name,
                    value: item.major_group_id
                })),
                checked: false,
            },
            {
                label: i18n.t('menu_and_dishes_page_form_sub_type'),
                key: 'family_group',
                value: -1,
                type: 'select',
                items: this.props.mergetypes.map(item => ({
                    label: item.family_group_name,
                    value: item.family_group_id
                })),
                checked: false,
            },
            {
                key: 'class_id',
                label: i18n.t('menu_and_dishes_page_menu_dish_has_discount'),
                type: 'select',
                checked: false,
                value: 6,
                items: [
                    { label: i18n.t('menu_and_dishes_page_has_discount'), value: 6 },
                    { label: i18n.t('menu_and_dishes_page_has_not_discount'), value: 3 }
                ],
            },
            {
                key: 'rule_lnr_limit_enable',
                label: i18n.t('menu_and_dishes_page_continue_to_add'),
                type: 'select',
                checked: false,
                value: 0,
                items: [
                    { label: i18n.t('google_text_no'), value: 0 },
                    { label: i18n.t('google_text_yes'), value: 1 }
                ],
            },
            {
                key: 'rules_ignore_the_display',
                label: i18n.t('menu_and_dishes_page_dish_edition_ignore_turn_rule'),
                type: 'select',
                checked: false,
                value: 0,
                items: [
                    { label: i18n.t('google_text_no'), value: 0 },
                    { label: i18n.t('google_text_yes'), value: 1 }
                ],
            },
            {
                key: 'upload_image_file',
                label: i18n.t('dis_img_setting_page_batch_upload'),
                type: 'upload_img',
                checked: false,
                value: 0,
            },
        ],
        // 是否显示批量设置弹窗
        isShowMultiSettingDialog: false,
        // 表格每页行数
        rowsPerPage: 500,
        // 当前页
        currPage: 0,
        // 总数
        count: 0,
        // 按钮加载
        buttonLoading: false,
        // 菜品图片
        avatarUrl: '',
        // 过滤条件
        filterListValues: {},
        // 搜索文本
        searchText: ''
    }



    // 存储当前table的状态
    public currentTableState: any = null;

    // 存储一级菜单列表
    public firstMenusList: { value: number, label: string }[] = [];

    // 存储二级菜单列表
    public secondMenusList: { value: number, label: string, firstId: number, belongMenuName: string }[] = [];

    constructor(props: Props) {
        super(props)
        this.handleMenuListDialogShow = this.handleMenuListDialogShow.bind(this)
        this.handleTableToolbarSelectRender = this.handleTableToolbarSelectRender.bind(this)
        this.renderMenuListDialog = this.renderMenuListDialog.bind(this)
    }

    // *********************
    // Life Cycle Function
    // *********************
    async componentDidMount() {
        this.setState({
            isLoading: true
        }, async () => {
            await this.init()
            this.setState({
                isLoading: false
            })
        })
    }

    // *********************
    // Default Function
    // *********************
    init = async () => {
        try {
            this.firstMenusList = [];
            this.secondMenusList = [];
            const { menuData } = this.props;
            // 存储一二级菜单数据
            menuData.forEach(firstMenu => {
                this.firstMenusList.push({
                    label: firstMenu.main_group_name || '',
                    value: firstMenu.main_group_id || -2,
                })
                firstMenu.menu_item_slu?.forEach(secondMenu => {
                    this.secondMenusList.push({
                        label: secondMenu.dmi_slu_name || '',
                        value: secondMenu.dmi_slu_id || -2,  // -1是调味品
                        // 一级菜单id
                        firstId: firstMenu.main_group_id || -2,
                        // 所属小类-大类
                        belongMenuName: `${secondMenu.dmi_slu_name || ''} - ${firstMenu.main_group_name || ''}`
                    })
                })
            })
            await this.getDish();
        } finally {
            this.setState({
                isLoading: false,
            })
        }
    }

    async getDish() {
        this?.canceler?.();
        this.setState({ isLoading: true });
        const { filterListValues, searchText } = this.state;
        const allDishesList: MenuDish[] = [];
        let count = 0;
        // 搜索文本
        const searchObj = searchText ? { item_name1: searchText } : {};

        const params = {
            pag_page: this.state.currPage + 1,
            pag_per_page: this.state.rowsPerPage,
            ...filterListValues,
            ...searchObj
        }
        // 获取全部菜品

        // 取消请求
        const cancelToken = new axios.CancelToken(Canceler => this.canceler = Canceler);
        const result: { result: MenuDish[], count: number } = (await apiManage_rbp.get_menu_item_v3(params, { cancelToken })) as unknown as { result: MenuDish[], count: number };
        if (!_.get(result, 'error')) {
            count = result.count;
            result?.result?.forEach(item => {
                // 过滤不在菜单内的菜品
                const second = this.secondMenusList.find(temp => temp.value === item.slu_id)
                if (second) {
                    item.main_group_id = second.firstId;
                    item.belong_menu_name = second.belongMenuName;
                    allDishesList.push(item)
                }
            })
            this.setState({
                allDishesList,
                count,
                isLoading: false
            })
        } else {
            if (_.get(result, 'message') !== 'canceled') {
                this.setState({
                    isLoading: false
                })
            }
        }
    }



    /**
     * 选中项，表格头部工具栏显示
     * @returns
     */
    public handleTableToolbarSelectRender(
    ) {
        // view
        return (
            <>
                <div style={{ padding: '4px 12px', }}>
                    {/* 右侧按钮组 */}
                    <ButtonComponent
                        titleText={i18n.t('menu_and_dishes_page_multi_setting_dishes')}
                        handleClick={() => {
                            // this.setState({
                            //     isShowMultiSettingDialog: true,
                            // })
                            this.dialogRef?.current?._onSetDialogFunc(true);
                        }}
                    >
                        {i18n.t('menu_and_dishes_page_multi_setting_dishes')}
                    </ButtonComponent>
                    <ButtonComponent titleText={i18n.t('menu_and_dishes_page_transfer_dishes')} handleClick={() => {
                        this.handleMenuListDialogShow(true, DISH_ACTION_TITLE.TRANSFER_DISH)
                    }}>
                        <SyncAlt />
                    </ButtonComponent>
                    <ButtonComponent
                        titleText={i18n.t('menu_and_dishes_page_copy_dishes')}
                        handleClick={() => {
                            this.handleMenuListDialogShow(true, DISH_ACTION_TITLE.COPY_DISH)
                        }}
                    >
                        <FileCopyOutlined />
                    </ButtonComponent>
                    <ButtonComponent
                        titleText={i18n.t('menu_and_dishes_page_delete_dish')}
                        handleClick={() => {
                            this.handleConfirmDialogDialogShow(true)
                        }}
                    >
                        <Delete />
                    </ButtonComponent>
                </div>
            </>
        )
    }

    /**
     * 批量设置对话框
     * @returns
     */
    public renderMultiSettingDialog(): JSX.Element {
        const { isShowMultiSettingDialog, multiSettingArr } = this.state

        return (
            <DialogComponent
                className='second-menu-mul-setting-dish'
                defaultHeaderProps={{
                    title: `${i18n.t('menu_and_dishes_page_multi_setting_dishes')}`,
                    onClose: () => {
                        this.setState({
                            isShowMultiSettingDialog: false
                        })
                    }
                }}
                open={isShowMultiSettingDialog}
                fullWidth={true}
                scroll={'paper'}
                onClose={() => {
                    this.setState({
                        isShowMultiSettingDialog: false
                    })
                }}
                footer={
                    <div>
                        <Button
                            color='primary'
                            variant='outlined'
                            onClick={() => {
                                this.setState({
                                    isShowMultiSettingDialog: false
                                })
                            }}
                        >{i18n.t('google_text_public_button_cancel')}</Button>
                        <Box marginLeft={4} display='inline-block'>
                            <Button
                                color='primary'
                                variant='contained'
                                onClick={() => {
                                    this.onMultiSetConfirm()
                                }}
                            >{i18n.t('google_text_confirm')}</Button>
                        </Box>
                    </div>}
            >
                <Grid container spacing={2}>
                    {
                        multiSettingArr.map((item, index) => {
                            return (
                                <Grid key={index} item xs={12}>
                                    <ListItem>
                                        <ListItemIcon>
                                            <Checkbox
                                                edge='start'
                                                color='primary'
                                                checked={item.checked}
                                                onClick={() => this.onMultiCheck(item)}
                                                tabIndex={-1}
                                                disableRipple
                                            />
                                        </ListItemIcon>
                                        <Typography>{item.label}</Typography>
                                        {item.type === 'radio' &&
                                            <FormControl component='fieldset' className={'basic-radios'} disabled={!item.checked}>
                                                <Box display={'flex'} flexDirection={'row'} alignItems={'center'} justifyContent={'center'}>
                                                    {
                                                        (item.items || []).map((radioItem, index) => {
                                                            return (
                                                                <RadioGroup key={index} row aria-label='position' name='position' defaultValue='top' className='slecrtItem '>
                                                                    <FormControlLabel
                                                                        key={`${item.value}-${index}`}
                                                                        checked={radioItem.value === item.value}
                                                                        value={radioItem.value}
                                                                        control={<Radio color='primary' />}
                                                                        label={radioItem.label}
                                                                        onChange={(event: any) => {
                                                                            let val = event.currentTarget.value
                                                                            // 判断类型
                                                                            const type = typeof (radioItem.value);
                                                                            if (type === 'string') {
                                                                                val = String(val);
                                                                            }
                                                                            if (type === 'number') {
                                                                                val = Number(val);
                                                                            }
                                                                            this.onMultiChange(val, item.key)
                                                                        }}
                                                                    />
                                                                </RadioGroup>
                                                            )
                                                        })
                                                    }
                                                </Box>
                                            </FormControl>
                                        }
                                        {item.type === 'select' &&
                                            <Box flex={1} marginLeft={10}>
                                                <CommonInput
                                                    regularType='required'
                                                    select={true}
                                                    disabled={!item.checked}
                                                    items={item.items}
                                                    variant={'outlined'}
                                                    fullWidth
                                                    value={`${item.value}` as any}
                                                    onChange={(event: any) => {
                                                        const val = event.currentTarget.getAttribute('data-value');
                                                        this.onMultiChange(val, item.key)
                                                    }}
                                                />
                                            </Box>
                                        }

                                    </ListItem>
                                </Grid>
                            )
                        })
                    }
                </Grid>
            </DialogComponent>
        )
    }

    /**
     * 批量设置checked - onClick
     * @param setItem
     */
    public onMultiCheck = (setItem: {
        label: string;
        key: string;
        value: number | string;
        type: 'select' | 'radio' | 'upload_img';
        checked: boolean;
        items?: any[];
    }) => {
        const { multiSettingArr } = this.state
        const { checked, key } = setItem
        const afterMultiSettingArr = multiSettingArr.map(n => {
            if (n.key === key) {
                n.checked = !checked
            }
            return n
        })
        this.setState({
            multiSettingArr: afterMultiSettingArr,
        })
    }

    /**
     * 批量设置 -  onChange
     */
    public onMultiChange = (val: string | number, key: string) => {
        const { multiSettingArr } = this.state
        const afterMultiSettingArr = multiSettingArr.map(n => {
            if (n.key === key) {
                n.value = val
            }
            return n
        })
        this.setState({
            multiSettingArr: afterMultiSettingArr,
        })
    }

    /**
     * 批量设置确认 confirm
     */
    public onMultiSetConfirm = async () => {
        const { multiSettingArr, dishSelected, avatarFile } = this.state;
        if (!multiSettingArr.length) {
            GlobalNotification.error(i18n.t('menu_and_dishes_page_dish_option_null'))
            return
        }
        const param: any = {};
        let needUpdate = false;
        let uploadImgFlag = false;
        multiSettingArr.forEach(item => {
            if (item.checked) {
                param[item.key] = item.value
                needUpdate = true
                if (item.key === 'upload_image_file') uploadImgFlag = true;
            }
        })
        if (!needUpdate) {
            GlobalNotification.error(i18n.t('menu_and_dishes_page_please_select_modify_item'));
            return
        }
        // loading
        setLoading(true);
        this.setState({
            isShowMultiSettingDialog: false,
            // 批量设置后取消勾选状态
            dishSelected: [],
            isLoading: true
        }, async () => {
            this.ReactVirtualizedTableRef?.current?.setSelected([]);
            if (avatarFile && uploadImgFlag) {
                const dishItemIds = dishSelected.map(dish => {
                    const itemId = dish.item_id;
                    return itemId
                })
                const chunkArrs = _.chunk(dishItemIds, 10);
                for (let i = 0, len = chunkArrs.length; i < len; i++) {
                    await Promise.all(chunkArrs[i].map(itemId => apiManage_rbp.post_dishes_image(`${itemId},${itemId}_s`, avatarFile as File)))
                }
            }
            delete param.upload_image_file;
            const res = await apiManage_rbp.patch_dishes(dishSelected.map(item => ({ ...param, item_id: item.item_id, slu_id: item.slu_id })));
            if (!_.get(res, 'error') && res.affectedRows > 0) {
                GlobalNotification.success(i18n.t('global_text_operate_success'));
                await this.init();
            } else {
                GlobalNotification.error(i18n.t('global_text_operate_failure'));
            }
            this.setState({ isLoading: false });

            // eslint-disable-next-line react/no-direct-mutation-state
            this.state.avatarFile = undefined;
            // eslint-disable-next-line react/no-direct-mutation-state
            this.state.avatarUrl = '';
        });

    }


    /**
     * $ new 批量设置确认 confirm
     */
    public onMultiDialogSetConfirm = async (settingParams: { [key: string]: any }, avatarFile?: File) => {
        const { dishSelected } = this.state;
        if (!Object.keys(settingParams).length && !avatarFile) {
            GlobalNotification.error(i18n.t('menu_and_dishes_page_dish_option_null'))
            return
        }
        // 过敏原 其他菜品标识特殊处理
        Object.keys(settingParams).forEach(key => {
            if (['allergen', 'other_detail_info'].includes(key)) settingParams[key] = settingParams[key].reduce((pre: string, cur: string) => pre += `${cur}*`, '').slice(0, -1);
        })
        const param: any = settingParams;
        // loading
        this.setState({
            // 批量设置后取消勾选状态
            dishSelected: [],
            isLoading: true
        }, async () => {
            this.ReactVirtualizedTableRef?.current?.setSelected([]);
            const res = await apiManage_rbp.patch_dishes(dishSelected.map(item => ({ ...param, item_id: item.item_id, slu_id: item.slu_id })));
            if (!_.get(res, 'error') && res.affectedRows > 0) {
                GlobalNotification.success(i18n.t('global_text_operate_success'));
                await this.init();
            } else {
                GlobalNotification.error(i18n.t('global_text_operate_failure'));
            }
            this.setState({ isLoading: false });
        });
    }

    /**
     * 控制菜单列表对话框显示
     * @param open
     * @param actionTitle
     */
    public handleMenuListDialogShow(open: boolean, actionTitle?: DISH_ACTION_TITLE) {
        if (actionTitle) {
            this.setState({
                actionTitle
            })
        }
        this.setState({
            isShowMenuListDialog: open,
            checkedSecondMenuIds: [],
            checkedSecondMenus: [],
        })
    }

    /**
     * 菜单列表对话框
     * @returns
     */
    public renderMenuListDialog(): JSX.Element {
        const { menuData } = this.props
        const { isShowMenuListDialog, checkedSecondMenuIds, actionTitle, buttonLoading } = this.state
        // 左侧菜单
        // $ 对话框内的菜单可多选，新增checkedSecondMenuIds字段
        const menu = menuData.map((item) => ({
            key: `${item.main_group_id}`,
            title: item.main_group_name ?? '',
            children: (item.menu_item_slu || []).map((subMenuItem) => ({
                key: `sub-${subMenuItem.dmi_slu_id}`,
                title: subMenuItem.dmi_slu_name ?? '',
                dataSource: subMenuItem,
                checkedSecondMenuIds,
                originId: subMenuItem.dmi_slu_id,
            })),
            dataSource: item,
        }))
        return (
            <DialogComponent
                defaultHeaderProps={{
                    title: `${i18n.t(actionTitle)}`,
                    onClose: () => {
                        this.handleMenuListDialogShow(false)
                    }
                }}
                open={isShowMenuListDialog}
                fullWidth={true}
                maxWidth={'sm'}
                scroll={'paper'}
                onClose={() => {
                    this.handleMenuListDialogShow(false)
                }}
                footer={
                    <div>
                        <Button
                            color='primary'
                            variant='outlined'
                            onClick={() => {
                                this.handleMenuListDialogShow(false)
                            }}
                        >{i18n.t('google_text_public_button_cancel')}</Button>
                        <Box marginLeft={4} display='inline-block'>
                            <Button
                                color='primary'
                                variant='contained'
                                disabled={!checkedSecondMenuIds?.length}
                                onClick={async () => {
                                    await this.onConfirmHandleDish()
                                }}
                            >{i18n.t('google_text_confirm')}
                                {
                                    buttonLoading &&
                                    <Backdrop
                                        style={{ zIndex: 999, position: 'absolute' }}
                                        open={buttonLoading}
                                    >
                                        <CircularProgress size={24} color={'primary'} />
                                    </Backdrop>
                                }
                            </Button>
                        </Box>
                    </div>}
            >
                <MenuListComponent
                    fullWidth
                    isHideContextMenu={true}
                    menu={menu}
                    isShowCheckBox={true}
                    handleClick={(menu: MenuListItem) => {
                        this.handleCheckBoxChange(menu)
                    }}
                    style={{ maxHeight: 'unset' }}
                />
            </DialogComponent>
        )
    }

    /**
     * 点击菜单
     * checkBox控制事件 （仅针对二级菜单）
     * @param menu
     * @param index
     */
    public handleCheckBoxChange(menu: MenuListItem) {
        // 一级菜单
        if (menu.children) {
            return
        }
        // eslint-disable-next-line prefer-const
        let { checkedSecondMenuIds, actionTitle, checkedSecondMenus } = this.state
        const menuId = _.get(menu, 'dataSource.dmi_slu_id')
        const menuData: SecondMenu = _.get(menu, 'dataSource')
        const filterIndex = checkedSecondMenuIds.findIndex((item) => {
            return item === menuId
        })
        // 复制菜品操作 （可多选）
        if (actionTitle === DISH_ACTION_TITLE.COPY_DISH) {
            if (filterIndex === -1) {
                // 选中
                checkedSecondMenuIds.push(menuId)
                checkedSecondMenus.push(menuData);
            } else {
                // 取消选中
                checkedSecondMenuIds.splice(filterIndex, 1)
                checkedSecondMenus.splice(filterIndex, 1)
            }
        }
        // 转移菜品操作 （单选）
        if (actionTitle === DISH_ACTION_TITLE.TRANSFER_DISH) {
            if (filterIndex === -1) {
                // 选中
                checkedSecondMenuIds[0] = menuId
                checkedSecondMenus = [menuData]
            } else {
                // 取消选中
                checkedSecondMenuIds.splice(filterIndex, 1)
                checkedSecondMenus = [];
            }
        }

        this.setState({
            checkedSecondMenuIds: [...checkedSecondMenuIds],
            checkedSecondMenus: [...checkedSecondMenus]
        })
    }

    /**
     * 复制、转移菜品确认事件
     * @returns
     */
    public async onConfirmHandleDish() {
        this.setState({
            buttonLoading: true
        }, async () => {
            const { dishSelected, checkedSecondMenuIds, checkedSecondMenus, actionTitle } = this.state
            if (actionTitle === DISH_ACTION_TITLE.COPY_DISH) {
                // $ 复制菜品
                // 过滤选中的菜品字段(只传菜品id)
                const dishIds = dishSelected.map((dish: MenuDish) => {
                    return dish.item_id
                })
                // 选中的二级菜单ids
                const secondMenuIds = _.cloneDeep(checkedSecondMenuIds)
                // 请求接口
                await this.props.onChangeDishesCopy(dishIds as number[], secondMenuIds, checkedSecondMenus);
                await this.init();
            }

            if (actionTitle === DISH_ACTION_TITLE.TRANSFER_DISH) {
                // $ 转移菜品
                // 处理传参
                const params = dishSelected.map((dish: MenuDish) => {
                    const obj: MenuDish = {
                        item_id: dish.item_id,
                        slu_id: checkedSecondMenuIds[0],
                        not_joining_global_limit: checkedSecondMenus[0].not_joining_global_limit
                    }
                    return obj
                })
                await this.props.onChangeDishesTransfer(params);
                await this.init();
            }

            this.setState({
                isShowMenuListDialog: false,
                // 复制、转移菜品后取消勾选状态
                dishSelected: [],
                buttonLoading: false
            })
            this.ReactVirtualizedTableRef?.current?.setSelected([]);
        })
    }

    /**
     * 控制确认操作对话框显示
     * @returns
     */
    public handleConfirmDialogDialogShow(open: boolean) {
        this.setState({
            isShowConfirmDialog: open,
        })
    }

    /**
     * 确认操作对话框
     * @returns
     */
    public renderConfirmDialog(): JSX.Element {
        const { isShowConfirmDialog, buttonLoading } = this.state

        return (
            <DialogComponent
                defaultHeaderProps={{
                    title: i18n.t('menu_and_dishes_page_delete_dish'),
                    onClose: () => {
                        this.handleConfirmDialogDialogShow(false)
                    }
                }}
                open={isShowConfirmDialog}
                fullWidth={true}
                maxWidth={'xs'}
                onClose={() => {
                    this.handleConfirmDialogDialogShow(false)
                }}
                footer={
                    <div>
                        <Button
                            color='primary'
                            variant='outlined'
                            onClick={() => {
                                this.handleConfirmDialogDialogShow(false)
                            }}
                        >{i18n.t('google_text_public_button_cancel')}</Button>
                        <Box marginLeft={4} display='inline-block'>
                            <Button
                                color='primary'
                                variant='contained'
                                onClick={() => {
                                    this.deleteDishesAction()
                                }}
                                style={{ position: 'relative' }}
                            >
                                {i18n.t('google_text_confirm')}
                                {
                                    buttonLoading &&
                                    <Backdrop
                                        style={{ zIndex: 999, position: 'absolute' }}
                                        open={buttonLoading}
                                    >
                                        <CircularProgress size={24} color={'primary'} />
                                    </Backdrop>
                                }
                            </Button>
                        </Box>
                    </div>}
            >
                <span>{i18n.t('dinner_table_page_whether_confirm_delete')}</span>
            </DialogComponent>
        )
    }

    /**
     * 删除菜品操作
     * @returns
     */
    public async deleteDishesAction() {
        this.setState({
            buttonLoading: true
        }, async () => {
            const { dishSelected } = this.state
            const dishIds = dishSelected.map((dish: MenuDish) => {
                return {
                    item_id: dish.item_id as number,
                    slu_id: dish.slu_id as number,
                }
            })
            await this.props.handleDeleteDishes(dishIds);
            await this.init();
            this.setState({
                isShowConfirmDialog: false,
                // 删除后取消勾选状态
                dishSelected: [],
                buttonLoading: false,
            })
            this.ReactVirtualizedTableRef?.current?.setSelected([]);

        })
    }

    /**
     * 设置过滤条件
     */
    setFilterList(val: { [key: string]: string[] }) {
        this.setState({ filterListValues: val, allDishesList: [], currPage: 0 }, () => {
            this.getDish()
        })
    }
    // *********************
    // View
    // *********************

    render() {
        const { onCancel, open } = this.props;
        const { isLoading, allDishesList, menuDishData, isShowMenuDishData, rowsPerPage, currPage, count } = this.state

        const columns: HeadCell[] = [
            {
                id: 'item_name1',
                label: i18n.t('base_setting_dish_name'),
                width: '20%',
            },
            {
                id: 'belong_menu_name',
                label: i18n.t('menu_and_dishes_page_belong_menus'),
                width: '20%',
            },
            {
                id: 'price_1',
                label: i18n.t('menu_and_dishes_page_dine_in_price'),
            },
            {
                id: 'takeout_price_1',
                label: i18n.t('menu_and_dishes_page_takeout_price'),
            },
            {
                id: 'print_class',
                label: i18n.t('menu_and_dishes_page_print_class'),
                renderFunction: (row: MenuDish) => {
                    return (
                        <Typography variant='subtitle1' >
                            {
                                row?.print_class ?
                                    _.find(this.props.printGroup, (iitem) => iitem.print_class_id === row?.print_class)?.print_class_name
                                    :
                                    i18n.t('print_setting_page_none0')
                            }
                        </Typography>
                    )
                }
            },
            {
                id: 'nlu',
                label: i18n.t('rwa_setting_page_mnemonic_code'),
            },
            {
                id: 'rule_lnr_max_num',
                label: i18n.t('menu_and_dishes_page_rule_lnr_max_num'),
            },
            {
                id: 'item_type',
                label: i18n.t('menu_and_dishes_page_dish_type'),
                renderFunction: (row: MenuDish) => {
                    const itemType = ITEM_TYPE.find((item) => item.value === row?.item_type);
                    return (
                        <Typography variant='subtitle1' >
                            {itemType?.label || ''}
                        </Typography>
                    )
                }
            },
            {
                id: 'action',
                label: i18n.t('google_text_check_detail'),
                renderFunction: (row: MenuDish) => {
                    return (
                        <ButtonComponent action='VIEW' handleClick={() => {
                            // 当前菜品详情数据
                            this.setState({
                                isShowMenuDishData: true,
                                menuDishData: row,
                            })
                        }}>
                            <Visibility />
                        </ButtonComponent>
                    )
                }

            }
        ];
        // 过滤器配置
        const fillterSelects = [
            {
                title: i18n.t('menu_and_dishes_page_first_menu_class'),
                key: 'main_group_id',
                value: [],
                optionValues: this.firstMenusList.map(item => {
                    return {
                        label: item.label || '',
                        value: String(item.value),
                    }
                })
            },
            {
                title: i18n.t('menu_and_dishes_page_belong_menus'),
                key: 'second_group_id',
                value: [],
                optionValues: this.secondMenusList.map(item => {
                    return {
                        label: item.belongMenuName || '',
                        value: String(item.value),
                    }
                })
            },
            {
                title: i18n.t('menu_and_dishes_page_print_class'),
                key: 'print_class',
                value: [],
                optionValues: this.props.printGroup?.map((item) => {
                    return {
                        label: item.print_class_name || '',
                        value: item.print_class_id || 0,
                    }
                })
            },
            {
                title: i18n.t('menu_and_dishes_page_dish_type'),
                key: 'item_type',
                value: [],
                optionValues: ITEM_TYPE.map(item => {
                    return {
                        label: item.label || '',
                        value: String(item.value || 0),
                    }
                })
            },
            {
                title: i18n.t('menu_and_dishes_page_main_type'),
                key: 'major_group',
                value: [],
                optionValues: this.props.majorGroup.map((item) => ({
                    label: item.major_group_name || '',
                    value: item.major_group_id || 0,
                }))
            },
            {
                title: i18n.t('menu_and_dishes_page_sub_type'),
                key: 'family_group',
                value: [],
                optionValues: this.props.mergetypes.map((item) => ({
                    label: item.family_group_name || '',
                    value: item.family_group_id || 0,
                }))
            }
        ];

        return (
            <DialogComponent
                open={open}
                defaultHeaderProps={{
                    title: i18n.t('menu_and_dishes_page_all_menu_list_model'),
                    onClose: onCancel,
                }}
                heightSize={'large'}
            >
                {
                    <Box className='menu-library-page' >
                        <div style={{ display: isShowMenuDishData ? 'none' : 'block' }}>
                            <ReactVirtualizedTable
                                ref={this.ReactVirtualizedTableRef}
                                isLoading={isLoading}
                                data={allDishesList}
                                columns={columns}
                                allCount={count}
                                rowsPerPage={rowsPerPage}
                                currentPage={currPage}
                                changePageCallback={(params: { page: number; curRowsPerPage: number }) => {
                                    this.setState({
                                        currPage: params.page,
                                        rowsPerPage: params.curRowsPerPage,
                                        allDishesList: [],
                                        dishSelected: []
                                    }, () => {
                                        this.ReactVirtualizedTableRef?.current?.setSelected([]);
                                        this.getDish();
                                    })
                                }}
                                showChecked={1}
                                compareSymbol={'item_id'}
                                handleCheck={(selected) => {
                                    this.setState({ dishSelected: selected })
                                }}
                                customToolbarSelect={() => this.handleTableToolbarSelectRender()}
                                fillterSelects={fillterSelects}
                                onFilterChange={(val) => { this.setFilterList(val); }}
                                onSearchChange={(searchText) => { this.setState({ searchText }) }}
                                onSearch={() => {
                                    this.setState({
                                        currPage: 0,
                                        allDishesList: [],
                                        dishSelected: []
                                    }, () => {
                                        this.ReactVirtualizedTableRef?.current?.setSelected([]);
                                        this.getDish();
                                    })
                                }}
                            />
                        </div>
                        {/* 菜品详情 */}
                        {
                            isShowMenuDishData && <MenuDishComponent
                                menuListForSet={this.props.menuListForSet}
                                menuData={this.props.menuData}
                                detail={menuDishData as MenuDish}
                                handleClickBack={() => {
                                    this.setState({
                                        isShowMenuDishData: false,
                                        menuDishData: undefined,
                                    }, () => {
                                        this.currentTableState && this.tableRef?.current?.baseTableRefs?.current.setState({ ...this.currentTableState })
                                        this.currentTableState = null
                                    })
                                }}
                                getMenuData={this.init}
                                updateDetail={(menuDish) => {
                                    this.setState({
                                        menuDishData: menuDish
                                    })
                                }}
                                taxGroup={this.props.taxGroup}
                                condimentsGroup={this.props.condimentsGroup}
                                printGroup={this.props.printGroup}
                                priceSpecList={this.props.priceSpecList}
                                majorGroup={this.props.majorGroup}
                                mergetypes={this.props.mergetypes}
                            />
                        }
                        {/* 菜品列表对话框 */}
                        {this.renderMenuListDialog()}
                        {/* 确认操作对话框 */}
                        {this.renderConfirmDialog()}
                        {/* 菜品批量设置对话框 */}
                        {/* {this.renderMultiSettingDialog()} */}
                        <MuliSettingDishDialog
                            ref={this.dialogRef}
                            taxGroup={this.props.taxGroup}
                            condimentsGroup={this.props.condimentsGroup}
                            printGroup={this.props.printGroup}
                            majorGroup={this.props.majorGroup}
                            mergetypes={this.props.mergetypes}
                            priceSpecList={this.props.priceSpecList}
                            onMultiDialogSetConfirm={this.onMultiDialogSetConfirm}
                        />
                    </Box>
                }
            </DialogComponent >
        )
    }
}

// *********************
// Type
// *********************
type Props = {
    // 开关
    open: boolean;
    // 取消
    onCancel: () => void;
    // 刷新菜单数据
    getMenuData: () => void;
    // 菜单数据（含菜品，供套餐选择菜品使用）
    menuListForSet: FirstMenu[];
    // 菜单源数据
    menuData: FirstMenu[];
    // 税率组
    taxGroup: TaxGroup[];
    // 调味品组
    condimentsGroup: Condiments[];
    // 打印组(岗位)
    printGroup: any[];
    // 报表主类别
    majorGroup: any[];
    // 报表子类别
    mergetypes: any[];
    // 菜品规格列表
    priceSpecList: ItemUnit[];
    // 底部确认
    onFtConfirm?: (detailData: MenuDish) => void;
    // 批量转移菜品
    onChangeDishesTransfer: (dishes: MenuDish[]) => Promise<void>;
    // 批量复制菜品
    onChangeDishesCopy: (dishIds: number[], secondMenuIds: number[], secondMenus: SecondMenu[]) => Promise<void>;
    // 批量删除菜品
    handleDeleteDishes: (dishIds: { item_id: number, slu_id: number }[]) => Promise<void>;
}
type State = {
    // 是否加载中
    isLoading: boolean;
    // 全部菜品
    allDishesList: MenuDish[];
    // 当前选中菜品详情
    menuDishData: MenuDish | undefined;
    // 当前选中的菜品
    dishSelected: MenuDish[];
    // 表格每页行数
    rowsPerPage: number;
    // 当前页
    currPage: number;
    // 总数
    count: number,
    // 是否显示菜品详情
    isShowMenuDishData: boolean;
    // 批量设置数组
    multiSettingArr: Array<{
        label: string;
        key: string;
        value: number | string;
        type: 'select' | 'radio' | 'upload_img';
        checked: boolean;
        items?: any[];
    }>
    // 是否显示批量设置弹窗
    isShowMultiSettingDialog: boolean;
    // 菜品操作标题
    actionTitle: DISH_ACTION_TITLE;
    // 是否显示菜单列表对话框
    isShowMenuListDialog: boolean;
    // 是否显示确认对话框
    isShowConfirmDialog: boolean;
    // 当前选中的二级菜单id
    checkedSecondMenuIds: number[];
    // 当前选中的二级菜单
    checkedSecondMenus: SecondMenu[];
    // 按钮加载
    buttonLoading: boolean;
    // 菜品图片
    avatarUrl: string;
    // 菜品图片文件
    avatarFile?: File;
    // 过滤条件
    filterListValues: { [key: string]: string[] };
    // 搜索文本
    searchText: string;
}

